<template>
  <div class="flex-grow-1 d-flex flex-column overflow-y-hidden">
    <div class="a-header">
      <span class="a-header--title slide-down-enter-active">
        View Notifications
      </span>
      <div class="d-flex">
        <a-button
          size="large"
          class="a-header--button slide-down-enter-active mr-3"
          @click="onBulkEdit"
        >
          <a-icon type="edit" theme="filled" />
          Bulk Edit
        </a-button>
        <a-button
          size="large"
          class="a-header--button slide-down-enter-active"
          type="primary"
          @click="onAdd"
        >
          <img class="mr-2 icon-size" src="@assets/icon/plus.svg" />
          Add New
        </a-button>
      </div>
    </div>
    <div v-if="isLoading" class="d-flex justify-content-center align-items-center pt-35-px">
      <Spinner />
    </div>
    <transition name="slide-up">
      <div v-if="!isLoading" class="a-filter">
        <a-row class="full-w" type="flex" justify="start" :gutter="16">
          <a-col :span="5">
            <div class="full-w a-input-group" :class="{ active: !!filterParams.search }">
              <a-button size="large">
                <a-icon type="search" />
              </a-button>
              <a-input class="custom-prefix" placeholder="Search" @change="onSearch" />
            </div>
          </a-col>
        </a-row>
      </div>
    </transition>
    <div v-resize="elSizeChange" class="a-body flex-grow-1 overflow-y-hidden">
      <transition name="slide-up">
        <template v-if="!isLoading">
          <PaginationTable
            :pagination="pagin"
            :columns="NotificationListColumn"
            :dataSource="filterData"
            :tableSize="tableSize"
          >
            <div slot="url" slot-scope="{ record }" class="text-truncate d-block">
              <a :href="record.url && record.url.url" class="url">
                {{ record.url && record.url.url }}
              </a>
            </div>
            <div slot="contact_group" slot-scope="{ record }">
              {{ record.contact_group.description }}
            </div>
            <div slot="notification_type_name" slot-scope="{ record }">
              {{ record.notification_type_name }}
            </div>
            <template slot="operation" slot-scope="{ record }">
              <a-dropdown placement="topLeft">
                <a-icon class="operation" type="ellipsis" />
                <a-menu slot="overlay" class="operation-menu">
                  <a-menu-item>
                    <a-icon type="edit" />
                    <router-link class="nav-link-detail" :to="'/notification/' + record.id">
                      Edit
                    </router-link>
                  </a-menu-item>
                  <a-menu-item>
                    <div class="full-wh" @click="showDeleteConfirm(record)"><img class="mr-2" src="@assets/icon/delete.svg" /> Delete</div>
                  </a-menu-item>
                </a-menu>
              </a-dropdown>
            </template>
          </PaginationTable>
        </template>
      </transition>
    </div>
    <div class="a-footer">
      <PaginationBar :pageSize.sync="pagin.pageSize" :total="pagin.total" @change="paginChange" />
    </div>
  </div>
</template>

<script>
  import { PAGE_OPTIONS } from '@constants/pageOptions';
  import { NOTIFICATION_TYPES } from '@constants/notifications';
  import { NotificationListColumn } from '../columnsTable/NotificationListColumn';
  import NotificationService from '../services/notification.service';

  export default {
    name: 'NotificationList',
    data() {
      var pageSize = Number(window.localStorage.getItem("pageSize"));
      if(!pageSize)
       pageSize = 5;

      return {
        PAGE_OPTIONS,
        NOTIFICATION_TYPES,
        NotificationListColumn,
        data: [],
        filterData: [],
        filterParams: {
          search: '',
        },
        pagin: {
          current: 1,
          pageSize: pageSize,
          total: 0,
        },
        isLoading: true,
        tableSize: {
          height: '',
          width: '',
        },
      };
    },
    mounted() {
      this.getList();
    },
    methods: {
      filter() {
        const searchTerm = this.filterParams.search.trim().toLowerCase();
        this.filterData = searchTerm ? this.data.filter(item => item.url.url.toLowerCase().includes(searchTerm)) : this.data;
        this.pagin = {
          current: 1,
          pageSize: this.pagin.pageSize,
          total: this.filterData.length,
        };
      },
      onAdd() {
        this.$router.push('/notification/add');
      },
      onBulkEdit() {
        this.$router.push('/notification/bulk-edit');
      },
      onDelete(record) {
        NotificationService.delete(record.id).then(() => {
          this.$showSuccessMessage('Deleted Notification');
          this.getList();
        });
      },
      onSearch(event) {
        this.filterParams.search = event.target.value;
        this.filter();
      },
      paginChange(pagin) {
        this.pagin = { ...pagin };
      },
      async getList() {
        try {
          const data = await NotificationService.getList();
          this.data = (data || []).map((item, index) => {
            item.index = index + 1;
            const notifyType = NOTIFICATION_TYPES.find(type => type.id == item.notification_type);
            item.notification_type_name = notifyType && notifyType.name;
            return item;
          });
          this.filter();
        } catch (error) {
          this.$showMultiErrorMessage(error.messages || []);
        } finally {
          if (this.isLoading) {
            setTimeout(() => {
              this.isLoading = false;
            }, 300);
          }
        }
      },
      showDeleteConfirm(record) {
        this.$confirm({
          title: 'Are you sure delete this item?',
          okText: 'Yes',
          okType: 'danger',
          cancelText: 'No',
          onOk: () => {
            this.onDelete(record);
          },
        });
      },
      elSizeChange(size) {
        this.tableSize = size;
      },
    },
  };
</script>

<style lang="scss" scoped>
  .nav-link-detail {
    width: 100%;
    &:hover {
      text-decoration: underline;
    }
  }
  .nav-link-detail {
    display: inline-block;
  }
</style>
